import React from 'react';

export default function MaskComponent(props) {
  return (
    <>
      {
				props.mask ? (
  <span>
    ********
  </span>
				)
				  : (
  <span style={{ letterSpacing: 0.7 }}>
    {props.children}
  </span>
				  )
			}
    </>
  );
}
